import { useMemo } from 'react'

import generateRedirectUrlWithCacheKey from '@functions/generateRedirectUrlWithCacheKey'

function useRedirectUrlWithCacheKey(deps: (string|number)[]) {
  const redirectUrl = useMemo(generateRedirectUrlWithCacheKey, [...deps])

  return {
    redirectUrl,
  }
}

export default useRedirectUrlWithCacheKey
